/* Shared number/date formatters for the Insights reports (Work Order / Foundry / Manufacturing).
 * One source of truth so all three reports present numbers identically. Pure functions — no Vue,
 * no DOM. Reports import what they need (or spread `insightsFormatters` into methods for templates). */

export function num(v) { const n = Number(v); return isNaN(n) ? 0 : n; }
export function arr(x) { return Array.isArray(x) ? x : []; }

export function fmtInt(v) { if (v == null) return "—"; return Math.round(Number(v)).toLocaleString(); }

export function fmtNum(v) { if (v == null) return "—"; return Number(v).toLocaleString(undefined, { maximumFractionDigits: 1 }); }

export function fmtUsd(v) {
  if (v == null) return "—";
  const n = Number(v);
  return (n < 0 ? "-$" : "$") + Math.abs(n).toLocaleString(undefined, { maximumFractionDigits: 0 });
}

/* fraction (0.685) -> "68.5%" */
export function fmtPct(v) { if (v == null) return "—"; return (Number(v) * 100).toFixed(1) + "%"; }

/* already a percent (68.5) -> "68.5%" */
export function fmtPct1(v) { if (v == null) return "—"; return Number(v).toFixed(1) + "%"; }

export function absv(v) { return Math.abs(Number(v) || 0); }

/* Value formatter keyed by a unit tag ("usd" | "pct" | "count" | else number). Matches the
 * /overview card contract shared by all three reports. */
export function fmtVal(v, unit) {
  if (v == null) return "—";
  if (unit === "usd") return fmtUsd(v);
  if (unit === "pct") return fmtPct(v);
  if (unit === "count") return fmtInt(v);
  return fmtNum(v);
}

/* Robust date: accepts ISO strings/dates, renders "Jul 26, 25". */
export function fmtDate(s) {
  if (!s) return "—";
  const d = new Date(String(s).slice(0, 10) + "T00:00:00");
  return isNaN(d) ? s : d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "2-digit" });
}

/* Delta helpers for YoY overview cards. `higherBetter` flips good/bad. */
export function deltaClass(higherBetter, delta) {
  const up = Number(delta) >= 0;
  const good = higherBetter ? up : !up;
  return good ? "good" : "bad";
}
export function deltaArrow(delta) { return Number(delta) >= 0 ? "▲" : "▼"; }

/* Bundle for spreading into an Options-API component's methods so templates can call them:
 *   methods: { ...insightsFormatters }  */
export const insightsFormatters = {
  num, arr, fmtInt, fmtNum, fmtUsd, fmtPct, fmtPct1, absv, fmtVal, fmtDate, deltaClass, deltaArrow,
};
